import PropTypes from 'prop-types'

import * as Sc from './DefaultError.styles'

import illustrationError from 'assets/img/Illustration_error.svg'

const DefaultError = ({ actionText, description, title }) => (
  <Sc.DefaultErrorContainer>
    <Sc.Title>{title}</Sc.Title>
    <Sc.Body>{description}</Sc.Body>
    <br />
    <Sc.Body>{actionText}</Sc.Body>
    <Sc.ImageContainer>
      <img alt='Error' src={illustrationError} />
    </Sc.ImageContainer>
  </Sc.DefaultErrorContainer>
)

DefaultError.propTypes = {
  actionText: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

DefaultError.defaultProps = {
  linkText: null,
}

export default DefaultError
